function kebab(str) {
  return str.replace(/([a-z0-9])([A-Z])/g, (_s, trail, cap) => `${trail}-${cap.toLowerCase()}`).replace(" ", "-").toLowerCase();
}

export { kebab as k };
//# sourceMappingURL=kebab-_XTA8qsc.js.map
